
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490.2 490.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#777","d":"M200.9 369.9H85.8a9.86 9.86 0 100 19.8h106.6c3.1 8.6 11.4 14.7 21 14.7h63.2c9.6 0 17.9-6.1 21-14.7h106.7a9.86 9.86 0 100-19.8H289.2a9.86 9.86 0 00-9.9 9.9v2.2a2.65 2.65 0 01-2.6 2.6h-63.2a2.65 2.65 0 01-2.6-2.6v-2.2c-.1-5.5-4.5-9.9-10-9.9zm279.4 0h-26V141.8a9.86 9.86 0 10-19.8 0v238c0 5.5 4.5 9.9 10 9.9h25.9v13.6c0 14-11.4 25.4-25.4 25.4H45.2c-14 0-25.4-11.4-25.4-25.4v-13.6h25.9a9.86 9.86 0 009.9-9.9v-238a9.86 9.86 0 00-9.9-9.9 9.86 9.86 0 00-9.9 9.9v228.1H9.9a9.86 9.86 0 00-9.9 9.9v23.5c0 24.9 20.3 45.2 45.2 45.2H445c24.9 0 45.2-20.3 45.2-45.2v-23.5a9.86 9.86 0 00-9.9-9.9z"}}),_c('path',{attrs:{"fill":"#c60","d":"M283.6 111.3l-57.1 56.8-19.9-20c-3.9-3.9-10.1-3.9-14 0s-3.9 10.1 0 14l26.8 27c1.9 1.9 4.5 2.9 7 2.9s5-1 7-2.9l64.2-63.8c3.9-3.9 3.9-10.1 0-14-3.8-3.8-10.1-3.9-14 0z"}}),_c('path',{attrs:{"fill":"#777","d":"M367.3 41.7H122.9c-20 0-36.3 16.3-36.3 36.3v144.4c0 20 16.3 36.3 36.3 36.3h10.3v43.5c0 8.1 6.6 14.6 14.7 14.6 4.2 0 8.2-1.8 11-5.1l45.8-53h162.6c20 0 36.3-16.3 36.3-36.3V78c0-20-16.3-36.3-36.3-36.3zm16.5 180.7c0 9.1-7.4 16.5-16.5 16.5H200.1c-2.9 0-5.6 1.2-7.5 3.4l-39.7 45.9v-39.4c0-5.5-4.4-9.9-9.9-9.9h-20.2c-9.1 0-16.5-7.4-16.5-16.5V78c0-9.1 7.4-16.5 16.5-16.5h244.4c9.1 0 16.5 7.4 16.5 16.5v144.4h.1z"}})])
          )
        }
      }
    